import React from 'react'
import OffsetByExcelSteps from '../OffsetByExcelSteps'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import SelectOffsetKeysForm from './SelectOffsetKeysForm/SelectOffsetKeysForm'
import { getOffsetByExcelVerifyErrors, setOffsetByExcelStep } from 'src/features'

const SelectOffsetKeysStep: React.FC = () => {
  const dispatch = useAppDispatch()

  const { hasErrors } = useAppSelector(getOffsetByExcelVerifyErrors)

  const handleBackClick = () => dispatch(setOffsetByExcelStep(0))
  const handleSubmitClick = () => dispatch(setOffsetByExcelStep(2))


  return (
    <div className='fade-animation'>
      <SelectOffsetKeysForm />

      <OffsetByExcelSteps
        nextStepValue={2}
        beforeStepValue={0}
        handleSubmitClick={handleSubmitClick}
        handleBackClick={handleBackClick}
        isNextButtonDisabled={hasErrors}
      />
    </div>
  )
}

export default SelectOffsetKeysStep
